import {
  IEventCollectionData,
  IEventCollectionDataActiveEvents,
  IEventCollectionDataActiveTypeticketcollections,
  IEventCollectionMetadata,
} from 'meta/pages/v4/eventCollection'

type Path = string

export type CollectionState = Record<
  Path,
  {
    details?: IEventCollectionData
    events?: {
      data: Record<number, IEventCollectionDataActiveEvents>
      metadata: IEventCollectionMetadata
    }
    activeEvents?: {
      data: Record<number, IEventCollectionDataActiveEvents>
      metadata: IEventCollectionMetadata
    }
    activeTypeticketcollections?: {
      data: Record<number, IEventCollectionDataActiveTypeticketcollections>
      metadata: IEventCollectionMetadata
    }
  }
>

export const initialState: CollectionState = {}
